<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#" type="light" class="header-logo"
        ><router-link to="/" class="logo"
          ><logo />GSFlow</router-link
        ></b-navbar-brand
      >

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav id="nav">
          <b-nav-item><router-link to="/">Home</router-link></b-nav-item>
          <b-nav-item v-if="!loggedIn"
            ><router-link to="/login">Login</router-link></b-nav-item
          >
          <b-nav-item v-if="loggedIn"
            ><router-link to="/sessions">Sessions</router-link></b-nav-item
          >
          <top-header></top-header>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
import TopHeader from './components/top-header';
import Logo from './components/Logo';
import * as firebase from 'firebase/app';
import 'firebase/auth';

export default {
  components: { 'top-header': TopHeader, Logo },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    });
  },
  data() {
    return {
      loggedIn: false,
    };
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: AvenirNext, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  a {
    font-weight: bold;
    color: #ffffff;
    &.router-link-exact-active {
      color: #ffc20d;
    }
  }
}

.header-logo {
  display: inline-block;
  color: white;
  margin-right: 50px;

  a {
    text-decoration: none;
    color: #ffffff;
  }
}

svg {
  width: 80px;
  height: 50px;
  fill: currentColor;
  color: inherit;
}
</style>
